<template>
    <header class="p-3 mb-3 border-bottom">
        <nav class="navbar navbar-expand-lg text-light fixed-top" >
            <div class="container">
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#tp-navbar" aria-controls="tp-navbar" aria-expanded="false"
                    aria-label="Menu">
                    <i class="fas fa-bars"></i>
                </button>

                <div class="collapse navbar-collapse" id="tp-navbar">
                    <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                        <li class="nav-item"><router-link class="nav-link" to="/"><i class="fas fa-home"></i> Voorpagina</router-link></li>
                    </ul>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
import { useToast } from 'vue-toastification';

export default {
    name: 'HeaderBar',
    setup() {
        const toast = useToast();
        return { toast };
    }
}
</script>

<style scoped lang="scss">
@import '../scss/theme.scss';

nav {
    background: $tp_pink_dark;

    .nav-link {
        color: white;
        font-size: 1.5rem;
        font-weight: 500;

        &:hover, .router-link-active {
            color: $tp_pink !important;
        }
    }

    .navbar-toggler {
        color: white;
        border-color: white;
    }

    .btn-primary {
        color: white;
    }
}
</style>